// Shared bits of the /create studio (design language F): the sheet the voice
// picker and Sound settings open in, and small voice helpers.
import React from "react";
import { JamSheet } from "@jammable/ui-components/Dialog";
import VoiceImageJs from "../VoiceImage";

/* eslint-disable @typescript-eslint/no-explicit-any */

// VoiceImage is untyped JS whose props all read as required.
export const VoiceImage = VoiceImageJs as unknown as React.FC<any>;

export const voiceNames = (voices: any[]) =>
  voices
    .map((v) => v?.artistname)
    .filter(Boolean)
    .join(" & ");

// The pickers' sheet: JamSheet from packages/ui (an animated Radix dialog
// on desktop, a draggable vaul drawer on phones).
export const StudioSheet = ({
  open,
  title,
  onClose,
  children,
  footer,
  className,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** e.g. a wider dialog on desktop. */
  className?: string;
}) => (
  <JamSheet
    open={open}
    onOpenChange={(o) => !o && onClose()}
    title={title}
    footer={footer}
    className={className}
  >
    {children}
  </JamSheet>
);
